import { useEffect } from "react";
import { useConfirm, type ConfirmOptions } from "@omit/react-confirm-dialog";

type ConfirmFn = ReturnType<typeof useConfirm>;

let confirmImpl: ConfirmFn | null = null;

/** Expose `useConfirm` to Bryntum plugins / non-React callers. */
export function registerConfirmDialog(fn: ConfirmFn | null) {
  confirmImpl = fn;
}

export function confirmDialog(options: ConfirmOptions): Promise<boolean> {
  if (!confirmImpl) {
    console.error("confirmDialog: ConfirmDialogProvider / ConfirmDialogBridge not mounted");
    return Promise.resolve(false);
  }
  return confirmImpl(options);
}

/** Mount under ConfirmDialogProvider. */
export function ConfirmDialogBridge() {
  const confirm = useConfirm();

  useEffect(() => {
    registerConfirmDialog(confirm);
    return () => registerConfirmDialog(null);
  }, [confirm]);

  return null;
}
